module.exports = __webpack_public_path__ + "media/images/icon_minus_lightgreen-a67a9ff9429eb4fbfe266c0dcad34055.svg";